import { SVGProps, Ref, forwardRef } from 'react';

export const SquaresIntersectedFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                d="M8.038 17c.235 5.198 1.692 6 7.961 6 7 0 8-1 8-8s-1-8-8-8h-.037q.04.906.038 2c0 6.987-.996 7.996-7.962 8"
                fill="currentColor"
            />
            <path
                d="M8 1C1 1 0 2 0 9s1 8 8 8h.038A45 45 0 0 1 8 15c0-6.987.996-7.996 7.962-8C15.726 1.802 14.27 1 8 1"
                fill="currentColor"
            />
        </svg>
    )
);
SquaresIntersectedFilledSize24Glyph.displayName = 'SquaresIntersectedFilledSize24Glyph';
